import React, { Component } from "react";

export interface GroupProps {
    field?: any;
    label: String;
}

export default class BaseGroup extends Component<GroupProps, {}> {
    render() {
        return (
            <div>
                {this.props.label && (
                    <div className="inner-card-title">{this.props.label}</div>
                )}
            </div>
        );
    }
}
